import { render } from "./Question1.vue?vue&type=template&id=4ac81d7e"
import script from "./Question1.vue?vue&type=script&lang=js"
export * from "./Question1.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\vue.js-3\\service-provider-project\\service-provider\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__